import { OpUnitType } from 'dayjs'

import { AcceptedDayInput, day } from './day'

const cache: Map<string, boolean> = new Map()

export function isSame(date1: AcceptedDayInput, date2: AcceptedDayInput, unit?: OpUnitType | 'isoWeek') {
    date1 = day(date1)
    date2 = day(date2)

    // Check cache
    const key = `${date1.valueOf()}_${date2.valueOf()}_${unit}`
    const cacheValue = cache.get(key)
    if (cacheValue !== undefined) {
        return cacheValue
    }

    // Set cache
    const result = date1.isSame(date2, unit)
    cache.set(key, result)

    return result
}
